export class IdNotFoundError extends Error {}

export const isIdNotFound = (e: unknown) =>
  e instanceof IdNotFoundError ||
  (e instanceof Error && e.message.includes('Invalid UUID'));
